import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
  discoPrototypeStore,
  Liquidset,
} from 'client/app/apps/disco-prototype/dataStore/dexieStore';

type Props = {
  liquidsets: Liquidset[];
};

const LiquidsetTable: React.FC<Props> = ({ liquidsets }) => {
  const handleDelete = async (id: string) => {
    void discoPrototypeStore.deleteLiquidset(id);
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell align="right">Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {liquidsets.map(ls => (
          <TableRow key={ls.id}>
            <TableCell>{ls.name}</TableCell>
            <TableCell align="right">
              <IconButton
                aria-label="delete"
                color="error"
                onClick={() => handleDelete(ls.id)}
              >
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default LiquidsetTable;
